import React, { useState } from "react";
import toast from "../ui/toast";
import "./FormMoreInfo.css";

const BLOCKED_EMAILS = ["leroymerlin", "rinkas@hotmail.fr"];
const BLOCKED_COMPANIES = ["compardemenage.fr"];

const FormMoreInfo = ({ onSubmit: onSubmitProp, submitLabel = "Voir les résultats" }) => {
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    company: "",
    nbBusinesses: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    setValues((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const validate = () => {
    const errs = {};
    if (!values.firstName) errs.firstName = "Veuillez entrer votre prénom";
    if (!values.lastName) errs.lastName = "Veuillez entrer votre nom";
    if (!values.email) errs.email = "Veuillez indiquer votre email";
    else if (!/\S+@\S+\.\S+/.test(values.email))
      errs.email = "Email non valide";
    if (!values.company) errs.company = "Veuillez indiquer votre entreprise";
    if (!values.nbBusinesses)
      errs.nbBusinesses = "Indiquez le nombre d'établissements gérés.";
    else if (isNaN(Number(values.nbBusinesses)))
      errs.nbBusinesses = "Indiquez un nombre valide";
    return errs;
  };

  const isBlocked = () => {
    if (BLOCKED_EMAILS.some((b) => values.email.includes(b))) return true;
    if (BLOCKED_COMPANIES.some((b) => values.company.includes(b))) return true;
    return false;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;

    if (isBlocked()) {
      toast.warning(
        "Vous n'avez plus de crédit. Contactez-nous pour obtenir un audit.",
      );
      return;
    }

    setLoading(true);
    try {
      const data = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        company: values.company,
        nbBusinesses: Number(values.nbBusinesses),
      };
      await onSubmitProp(data);
    } catch (error) {
      console.log(error);
      toast.error("Erreur lors de la sauvegarde");
    } finally {
      setLoading(false);
    }
  };

  const hasErrors = Object.keys(errors).length > 0;

  return (
    <form className="info-form" onSubmit={onSubmit}>
      <p className="info-form__subtitle">
        Renseignez vos coordonnées pour accéder aux résultats.
      </p>

      <div className="info-form__row">
        <div className="info-form__field">
          <input
            className={`input${errors.firstName ? " input--error" : ""}`}
            placeholder="Prénom"
            autoFocus
            value={values.firstName}
            onChange={(e) => handleChange("firstName", e.target.value)}
          />
          {errors.firstName && (
            <span className="info-form__error">{errors.firstName}</span>
          )}
        </div>
        <div className="info-form__field">
          <input
            className={`input${errors.lastName ? " input--error" : ""}`}
            placeholder="Nom"
            value={values.lastName}
            onChange={(e) => handleChange("lastName", e.target.value)}
          />
          {errors.lastName && (
            <span className="info-form__error">{errors.lastName}</span>
          )}
        </div>
      </div>

      <div className="info-form__field">
        <input
          className={`input${errors.email ? " input--error" : ""}`}
          placeholder="Email professionnel"
          type="email"
          value={values.email}
          onChange={(e) => handleChange("email", e.target.value)}
        />
        {errors.email && (
          <span className="info-form__error">{errors.email}</span>
        )}
      </div>

      <div className="info-form__row">
        <div className="info-form__field info-form__field--grow">
          <input
            className={`input${errors.company ? " input--error" : ""}`}
            placeholder="Entreprise"
            value={values.company}
            onChange={(e) => handleChange("company", e.target.value)}
          />
          {errors.company && (
            <span className="info-form__error">{errors.company}</span>
          )}
        </div>
        <div className="info-form__field info-form__field--small">
          <input
            className={`input${errors.nbBusinesses ? " input--error" : ""}`}
            placeholder="Nb. établissements"
            type="number"
            min={1}
            max={100000}
            value={values.nbBusinesses}
            onChange={(e) => handleChange("nbBusinesses", e.target.value)}
          />
          {errors.nbBusinesses && (
            <span className="info-form__error">{errors.nbBusinesses}</span>
          )}
        </div>
      </div>

      <button
        className={`btn btn--primary btn--block info-form__submit${loading ? " btn--loading" : ""}`}
        disabled={loading}
        type="submit"
      >
        {loading ? "Chargement..." : submitLabel}
      </button>

      {hasErrors && (
        <p className="info-form__hint">
          Veuillez corriger les champs en rouge.
        </p>
      )}

      <p className="info-form__footer">
        Vos données restent confidentielles et ne seront jamais partagées.
      </p>
    </form>
  );
};

export default FormMoreInfo;
